import { LEAD_STATUSES } from '@user/components/Leads/LeadCard/typings'
import { OPPORTUNITY_STATUSES } from '@user/components/Opportunities/OpportunityCard/typings'
import { permissionDenied } from '@user/store/authorization'
import { useMemo } from 'react'
import { Props } from '../AgreementRequirements'
import { useFormPacketsEnabled } from '@user/store/tenantFeatures/hooks/useFormPacketsEnabled'
import { useAgreementAttachmentEnabled } from '@user/store/tenantFeatures/hooks/useAgreementAttachmentEnabled'

export function useData(props: Props) {
  const { canUpdate, leadStatus, oppStatus } = props
  const formPacketEnabled = useFormPacketsEnabled()
  const agreementAttachmentEnabled = useAgreementAttachmentEnabled()

  const isDisqualifiedLead = useMemo(() => {
    return !!leadStatus && leadStatus == LEAD_STATUSES.Disqualified
  }, [leadStatus])

  const isClosedOpportunity = useMemo(() => {
    return (
      !!oppStatus &&
      (oppStatus == OPPORTUNITY_STATUSES.Lost ||
        oppStatus == OPPORTUNITY_STATUSES.Won)
    )
  }, [oppStatus])

  const isDisabled = !canUpdate || isClosedOpportunity || isDisqualifiedLead

  const disabledText = useMemo(() => {
    if (!canUpdate) return permissionDenied

    if (isClosedOpportunity) {
      return `You cannot send an agreement for a closed Opportunity.`
    }

    if (isDisqualifiedLead) {
      return `You cannot send an agreement for a disqualified Lead.`
    }
  }, [canUpdate, isClosedOpportunity, isDisqualifiedLead])

  const enableCreateAgreement = useMemo(
    () => formPacketEnabled && agreementAttachmentEnabled && !isDisabled,
    [formPacketEnabled, agreementAttachmentEnabled, isDisabled],
  )

  return {
    disabledText,
    isDisqualifiedLead,
    isDisabled,
    formPacketEnabled,
    enableCreateAgreement,
  }
}
